import * as React from 'react';
import { connect } from 'react-redux';
import { Theme, withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { push } from "react-router-redux";
import { bindActionCreators } from 'redux';
import { RouteName } from '../../routeNames';
import { localizations } from '../../localization/localization';

const styles = (theme: Theme) => createStyles({
  button: {
    height: '2.476em',
    fontSize: '1.3125em',
    letterSpacing: '0.0357em',
    lineHeight: 1.333,
    fontFamily: 'Roboto'
  }
});

type LoginRegisterButtonsProps = WithStyles & { goToActions: typeof goActions };

class RegisterButton extends React.Component<LoginRegisterButtonsProps> {
  public render() {
    const { classes, goToActions } = this.props;
    return (
      <Button
        variant="contained"
        color="secondary"
        className={classes.button}
        onClick={() => goToActions.goTo(RouteName.RegisterUser)}
      >
        {localizations.register.registerUserTitle}
      </Button>
    );
  }
}

const goActions = {
    goTo: (location: string) => push(location)
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    goToActions: bindActionCreators(goActions, dispatch)
  }
}

export default withStyles(styles)(connect<any, { goToActions: any }, any>(null, mapDispatchToProps)(RegisterButton));



// WEBPACK FOOTER //
// ./src/landingPage/components/RegisterButton.tsx